import React from "react";
import { Select } from "antd";
import IconFont from "@/components/icon";
import { useTranslation } from "react-i18next";
import { RemindMode } from "@/api/calendar";
const { Option } = Select;

export function RemindSelect({
  onChange,
  isAllDay,
  value
}: {
  onChange: (p: RemindMode[]) => void;
  isAllDay: boolean;
  value: RemindMode[];
}) {
  const { t } = useTranslation("calendar");

  return (
    <Select
      mode="multiple"
      allowClear={false}
      showArrow={true}
      suffixIcon={<IconFont type="iconicon_down" className="anticon-down icon-more icon-toggle" />}
      showSearch={false}
      value={value}
      className="calendar-custom-multiple-select calendar-custom-select-arrow"
      onChange={(val: RemindMode[]) => {
        // eslint-disable-next-line no-param-reassign
        val = val.sort((a: string, b: string) => {
          return Number(b) - Number(a);
        });
        if (val.length > 0) {
          if (!val.includes(RemindMode.No)) {
            onChange(val);
          } else {
            let remindListCopy: RemindMode[] = value;
            if (remindListCopy.includes(RemindMode.No)) {
              let newVal = val.filter((item: any) => {
                return item !== RemindMode.No;
              });
              onChange(newVal);
            } else {
              let remindList: any[] = [];
              remindList.push(RemindMode.No);
              onChange(remindList);
            }
          }
        } else {
          let remindList: any[] = [];
          remindList.push(RemindMode.No);
          onChange(remindList);
        }
      }}
    >
      <Option value="0">{t("none")}</Option>
      {isAllDay ? (
        <>
          <Option value={`${60 * 9}`}>当天 9:00</Option>
          <Option value={`-${60 * (24 - 9)}`}>提前1天 9:00</Option>
          <Option value={`-${60 * (24 * 2 - 9)}`}>提前2天 9:00</Option>
          <Option value={`-${60 * (24 * 7 - 9)}`}>提前1周 9:00</Option>
        </>
      ) : (
        <>
          <Option value="-0">{t("when-begin")}</Option>
          <Option value="-5">{t("schedule-start-minute").replace("%s", "5")}</Option>
          <Option value="-10">{t("schedule-start-minute").replace("%s", "10")}</Option>
          <Option value="-15">{t("schedule-start-minute").replace("%s", "15")}</Option>
          <Option value="-30">{t("schedule-start-minute").replace("%s", "30")}</Option>
          <Option value="-45">{t("schedule-start-minute").replace("%s", "45")}</Option>
          <Option value="-60">{t("开始前1个小时")}</Option>
          <Option value={`-${60 * 2}`}>{t("开始前2个小时")}</Option>
          <Option value={`-${60 * 24}`}>
            {t("开始前1天")}
            {/* {this.state.beginTime
                                ? '(' + dayjs(this.state.beginTime).format('HH:mm') + ')'
                                : ''} */}
          </Option>
          <Option value={`-${60 * 24 * 2}`}>
            {t("开始前2天")}
            {/* {this.state.beginTime
                                ? '(' + dayjs(this.state.beginTime).format('HH:mm') + ')'
                                : ''} */}
          </Option>
          <Option value={`-${60 * 24 * 7}`}>{t("开始前1周")}</Option>
        </>
      )}
    </Select>
  );
}
